import { createSlice } from "@reduxjs/toolkit";
//

export const patientFilterSlice = createSlice({
  name: "patientFilter",
  initialState: {
    gender: "",
    value2: "",
    value3: "",
    os_name: "",
    user_type: "",
    recurring: "",
  },
  reducers: {
    gender: (state, action) => {
      state.gender = action.payload;
    },
    created_at: (state, action) => {
      const { payload } = action;
      state.value2 = payload;
    },
    appoint_date_from: (state, action) => {
      const { payload } = action;
      state.value3 = payload;
    },
    os_name: (state, action) => {
      const { payload } = action;
      state.os_name = payload;
    },
    user_type: (state, action) => {
      const { payload } = action;
      state.user_type = payload;
    },
    recurring: (state, action) => {
      const { payload } = action;
      state.recurring = payload;
    },
  },
});

export const {
  gender,
  created_at,
  appoint_date_from,
  os_name,
  user_type,
  recurring,
} = patientFilterSlice.actions;
export default patientFilterSlice.reducer;
